import { fetch } from '@onviobr/fetch';
/**
 * Creates a {@link ChunkLoaderV1} that will load a translations in JSON format from a GET request
 * @remarks The `{language}` keyword can be used in the URL and it will get replaced with the language code to be loaded.
 * @public
 * @example
 * Simple example:
 * ```
 * translationManager.addLoader(jsonHttpLoader('i18n/{language}.json'));
 * ```
 * @param url - URL to load the chunk from
 * @returns Instance of {@link ChunkLoaderV1}
 */
export function jsonHttpLoader(url) {
    return async (language) => {
        const response = await fetch(url.replace(/{language}/g, language), {
            method: 'GET',
        });
        if (response.status >= 400) {
            throw new Error(`Error during loading translation ${language}: ${response.status}`);
        }
        return response.json();
    };
}
